import React from 'react';

const AppStyles = () => (
  <style>{`
    @keyframes gradient {
      0% { background-position: 0% 50%; }
      50% { background-position: 100% 50%; }
      100% { background-position: 0% 50%; }
    }
    .animate-gradient {
      background-size: 200% 200%;
      animation: gradient 15s ease infinite;
    }
    @keyframes pulse {
      0% { transform: scale(1); }
      50% { transform: scale(1.1); }
      100% { transform: scale(1); }
    }
    .animate-pulse-flag {
      animation: pulse 2s ease-in-out infinite;
    }
    @keyframes fade-in {
      from { opacity: 0; transform: translateY(10px); }
      to { opacity: 1; transform: translateY(0); }
    }
    .animate-fade-in {
      animation: fade-in 0.5s ease-out;
    }
    @keyframes slide-down {
      from { opacity: 0; transform: translateY(-10px); }
      to { opacity: 1; transform: translateY(0); }
    }
    .animate-slide-down {
      animation: slide-down 0.3s ease-out;
    }
    .card-hover {
      transition: all 0.3s ease;
    }
    .card-hover:hover {
      transform: translateY(-2px);
      box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
    }
    .touch-scale:active {
      transform: scale(0.98);
    }
    .animate-on-scroll {
      opacity: 0;
      transform: translateY(10px);
    }
    .animate-on-scroll.animate-fade-in {
      opacity: 1;
      transform: translateY(0);
    }
    .countdown-number {
      display: inline-block;
    }
    .drop-shadow {
      filter: drop-shadow(0 2px 4px rgba(0,0,0,0.1));
    }
    .drop-shadow-md {
      filter: drop-shadow(0 4px 6px rgba(0,0,0,0.1));
    }
    @keyframes ping {
      75%, 100% {
        transform: scale(2);
        opacity: 0;
      }
    }
    .animate-ping {
      animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
    }
  `}</style>
);

export default AppStyles;